import { ModelBase } from 'store/model-base';

export class CmsEsim extends ModelBase {
    public static storeName: string = 'cmsEsim';

    public nav: CmsEsimNav;
    public landing: CmsEsimLanding;
    public progress: CmsEsimLanding;
    public pending: CmsEsimLanding;
    public success: CmsEsimLanding;
    public errors: CmsEsimErrorList;
}
